import { useMutation } from "@apollo/client";

import { ProtocolEditRoute_DeleteDocument } from "../mutations.generated";

export default function useProtocolEditRoute_Delete() {
    const [deleteProtocol, { loading, error }] = useMutation(ProtocolEditRoute_DeleteDocument);

    const remove = async (protocolId: string) => {
        await deleteProtocol({ variables: { input: { protocolId } } });
    };

    return {
        deleteProtocol: remove,
        loading,
        error,
    };
}
